import {SelectOption, SelectOptionsGroup} from "./CommonUIElementTypes";

export let SelectUtility = {
    selectOptionForId: function (id: string, options?: (SelectOption | SelectOptionsGroup)[]) {
        for (let option of (options || [])) {
            if ((option as SelectOptionsGroup).options) {
                let match = (option as SelectOptionsGroup).options.find((groupedOption) => '' + groupedOption.value === '' + id)
                if (match) {
                    return match
                }
            } else if ('' + (option as SelectOption).value === '' + id) {
                return option as SelectOption
            }
        }
        return null
    },

    modelArrayToSelectOptions: function (
        modelArray: any[],
        valueProperty?: string,
        labelProperty?: string,
        labelFunction?: Function
    ) {
        return (modelArray || []).map(function (model) {
            let label
            if (labelFunction) {
                label = labelFunction(model)
            } else {
                label = model[labelProperty || 'name'];
            }
            return {
                value: model[valueProperty || 'id'],
                label: label
            }
        })
    }
}
